<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Clearing.SelectActualReceiptAndPayment')"
    width="960px"
    :close-on-click-modal="false"
    class="app-main-inner actual-payment-dialog"
  >
    <!--  todo: config-module  -->
    <search-item
      ref="searchItem"
      :show-more-scheme="true"
      :show-simple="true"
      :expand-adv="true"
      sim-url=""
      adv-url=""
      :search-item-code="$t('Clearing.Invoice')"
      search-item-mode="querydata"
      config-module="800"
    />
    <div class="app-main-inner-row row-grid" style="min-height: 300px;">
      <cargo-ag-grid
        v-if="innerVisible"
        config-module="180601"
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination-right" style="padding: 0 10px;">
      <cargo-pagination
        :total="searchConditions.total"
        :page.sync="searchConditions.pageNum"
        :limit.sync="searchConditions.pageSize"
        @pagination="fetchData"
      />
      <div class="total-detail-popover">
        <span><b>USD:</b></span>
        <span><u>666666</u></span>
        <span><b>RMB:</b></span>
        <span><u>666666</u></span>
        <span><b>{{ $t('Clearing.EquivalentToRMB') }}</b></span>
        <span><u>666666</u></span>
      </div>
    </div>
    <div slot="footer">
      <el-button type="primary" no="1" @click="confirm">确认</el-button>
      <el-button no="2" @click="cancel">{{ $t('Clearing.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { getGridSelected, getGridSelectedIds } from '@/utils/agGrid'

export default {
  name: 'ActualPaymentDialog',
  components: { searchItem },
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      innerVisible: false,
      searchConditions: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      rowData: [],
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false
      },
      columnDefs: [
        {
          headerName: this.$t('Clearing.ReconciliationFlowNumber'),
          field: 'actualAmountNo'
        },
        {
          headerName: this.$t('Clearing.SettlementObject'),
          field: 'accountId'
        },
        {
          headerName: this.$t('Clearing.CounterpartyUnit'),
          field: 'paymentCompany'
        },
        {
          headerName: this.$t('Clearing.OurBank'),
          field: 'ourBank'
        },
        {
          headerName: this.$t('Clearing.PaymentNoticeNumber'),
          field: 'billPaymentNo'
        },
        {
          headerName: this.$t('Clearing.VoucherNumber'),
          field: 'voucherNo'
        },
        {
          headerName: this.$t('Clearing.BankSlipNumber'),
          field: 'bankWaterNo'
        },
        {
          headerName: this.$t('Clearing.ReconciliationPerson'),
          field: 'verificationBy'
        },
        {
          headerName: this.$t('Clearing.ReconciliationDate'),
          field: 'verificationDate'
        },
        {
          headerName: this.$t('Clearing.ReceiptpaymentDate'),
          field: 'payReceiveDate'
        },
        {
          headerName: this.$t('Clearing.VoucherDate'),
          field: 'voucherExportDate'
        },
        {
          headerName: this.$t('Payment.paymentType'),
          field: 'isAr'
        },
        {
          headerName: this.$t('Clearing.SlipStatus'),
          field: 'cashTransferState'
        },
        {
          headerName: this.$t('Clearing.ReceiptpaymentMethod'),
          field: 'type'
        },
        {
          headerName: this.$t('Clearing.WhetherPrepaid'),
          field: 'isPrepay'
        },
        {
          headerName: this.$t('Clearing.Currency'),
          field: 'currency'
        },
        {
          headerName: this.$t('Clearing.Amount'),
          field: 'amount'
        },
        {
          headerName: this.$t('Clearing.AmountReconciled'),
          field: 'verfiedAmount'
        },
        {
          headerName: this.$t('Clearing.Balance'),
          field: 'remainAmount'
        },
        {
          headerName: this.$t('Clearing.ActualAmountReceived'),
          field: 'arAmount'
        },
        {
          headerName: this.$t('Clearing.ActualPaymentAmount'),
          field: 'apAmount'
        },
        {
          headerName: this.$t('Clearing.FinancialExpense'),
          field: 'financialCost'
        },
        {
          headerName: this.$t('Clearing.ExchangeGainloss'),
          field: 'diffChange'
        },
        {
          headerName: this.$t('Clearing.SmallHead'),
          field: 'clearOdd'
        },
        {
          headerName: this.$t('Clearing.OriginalCurrencyDifference'),
          field: 'sourceRateDiff'
        },
        {
          headerName: this.$t('Clearing.Creator'),
          field: 'createdBy'
        },
        {
          headerName: this.$t('Clearing.Review'),
          field: 'approvedState'
        },
        {
          headerName: this.$t('Clearing.ReviewDate'),
          field: 'dateApproved'
        },
        {
          headerName: this.$t('Clearing.Void'),
          field: 'state'
        },
        {
          headerName: this.$t('Clearing.InvoiceInformation'),
          field: 'invoiceDetail'
        },
        {
          headerName: this.$t('Clearing.Remarks'),
          field: 'remark'
        },
        {
          headerName: this.$t('Clearing.AccountPerioddays'),
          field: 'creditTerm'
        },
        {
          headerName: this.$t('Clearing.CounterpartyVoucherNumber'),
          field: 'targetVoucherNo2Charge'
        },
        {
          headerName: this.$t('Clearing.VoucherDate2'),
          field: 'voucherExportDate2'
        }
      ]
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal, oldVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    fetchData() {},
    confirm() {
      const self = this
      getGridSelectedIds(this.gridOptions).then(ids => {
        if (ids.length !== 1) {
          self.$message.error(self.$t('common.tips.hasOneAtleast'))
        } else {
          this.$emit('selected', getGridSelected(this.gridOptions)[0])
          this.innerVisible = false
        }
      })
    },
    cancel() {
      this.innerVisible = false
    }
  }
}
</script>

<style lang="scss">
.actual-payment-dialog {
  .el-dialog__body {
    padding: 0 !important;
  }
}
</style>
